import { type P, type R, type E, call, get, put, n, truthy } from './support-b2';
/** Legacy PHP symbol: sync_legendary_creature_aps_pool_for_turn. */
export function syncLegendaryCreatureApsPoolForTurn(caster: R, env: E): boolean {
    const total = legendaryCreatureApsPoolTotal(caster.value, env);
    if (total === null) return false;
    put(caster, ['encounter_creatures','aps_total'],total); return true;
}

/** Read the pool without copying or mutating a held member. */
export function legendaryCreatureApsPoolTotal(caster: P, env: E): number | null {
    const type = call(env, 'item_field', { item_arr: caster, key:'item_type' }) ?? '';
    if (type === 'lair') return 1;
    if (type !== 'creature' || !truthy(call(env, 'layer_value', { item_arr:caster,layer_name:'legendary_creature' }))) return null;
    const encounter = call(env, 'ft_encounter_context', { creature_arr:caster });
    if (get(encounter,'encounter_creatures_arr') === null) return null;
    const count = call(env, 'count_player_characters_in_encounter_for_legendary_pool', { encounter_arr:encounter });
    const base = Math.max(3,n(call(env,'layer_value',{item_arr:caster,layer_name:'aps'}) ?? 3));
    return base + Math.max(0,count - 1);
}
